<template>
    <div class="container-pagination">
            <nav>
                    <ul class="pagination">
                            <li class="page-item" >
                                    <button class="page-link" @click="changePage(1)">
                                            Primera Página
                                    </button>
                            </li>
                            <li class="page-item">
                                    <button class="page-link" :disabled="current == 1" @click="previousPage()">
                                            Anterior
                                    </button>
                            </li>
                            <li class="page-item" ><label class="page-link">...</label></li>
                            <li class="page-item" v-if="(this.current > 1)">
                                    <button class="page-link" @click="changePage(current-1)">
                                            {{current-1}}
                                    </button>
                            </li>
                            <li class="page-item active"><button class="page-link">{{current}}</button></li>
                            <li class="page-item" v-if="currentEnd">
                                    <button class="page-link" @click="changePage(current+1)">
                                            {{current+1}}
                                    </button>
                            </li>
                            <li class="page-item"><label class="page-link">...</label></li>
                            <li class="page-item">
                            <button class="page-link" :disabled="current == end" @click="nextPage()">
                                    Siguiente
                            </button>
                            </li>
                            <li class="page-item">
                            <button class="page-link" @click="changePage(end)">
                            Última Página</button>
                            </li>
                    </ul>
            </nav>
    </div>
</template>
<script>
export default {
    name: 'TablePagination',
    props:{
        end: Number,
    },
    emits:['changedPage'],
    data(){
        return {
            current:1,
        }
    },
    methods:{
            nextPage(){
                this.current = this.current+1
                this.$emit('changedPage', this.current)
            },
            previousPage(){
                this.current = this.current-1
                this.$emit('changedPage', this.current)
            },
            changePage(number_page){
                this.current = number_page
                this.$emit('changedPage', this.current)
            }
    },
    computed:{
        currentStart: function(){
            return (this.current != 1) ?true:false
        },
        currentEnd: function(){
            return (this.current < this.end)?true:false
        }
    }
};
</script>
<style scoped>
.container-pagination {
    display: flex;
    justify-content: center;
}
.page-link {
        color: black;
}
.page-link:hover {
      background-color:rgba(220, 220, 220, 0.616);
      color: black;
}
.page-link:focus {
        color: black;
        box-shadow: none;
}
</style>